const ImyChapter3Status = [
  { value: 1, name: 'QualifiedIntermediary', description: 'Qualified Intermediary' },
  { value: 2, name: 'NonQualifiedIntermediary', description: 'Non Qualified Intermediary' },
  { value: 3, name: 'TerritoryFinancialInstitution', description: 'Territory Financial Institution' },
  { value: 4, name: 'UsBranch', description: 'US Branch' },
  { value: 5, name: 'WithholdingForeignPartnership', description: 'Withholding Foreign Partnership' },
  { value: 6, name: 'WithholdingForeignTrust', description: 'Withholding Foreign Trust' },
  { value: 7, name: 'NonwithholdingForeignPartnership', description: 'Nonwithholding Foreign Partnership' },
  { value: 8, name: 'NonwithholdingForeignSimpleTrust', description: 'Nonwithholding Foreign Simple Trust' },
  { value: 9, name: 'NonwithholdingForeignGrantorTrust', description: 'Nonwithholding Foreign Grantor Trust' },
];

ImyChapter3Status.findByName = (statusName) => {
  if (!statusName || statusName.length <= 0) {
    return null;
  }

  const status = ImyChapter3Status.find(x => x.name.toLowerCase() === statusName.toLowerCase());
  return status || null;
};

export default ImyChapter3Status;
